module.exports = __webpack_public_path__ + "static/media/paid-color.dd810b34.png";